import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { GenericStatusId, Id } from '@e-socna/data-layer';

import { formatDateTime } from '../utils/format-date-time.util';
import { useReferencesContext } from '../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { UserName } from './UserName';
import { GenericStatusIndicator } from './GenericStatusIndicator';

interface Props {
  readonly id: Id;
  readonly creatorId: Id;
  readonly createdAt: string;
  readonly updaterId: Id;
  readonly updatedAt: string;
  readonly statusId?: Id;
}

export const Admin = ({
  id,
  creatorId,
  createdAt,
  updaterId,
  updatedAt,
  statusId,
}: Readonly<Props>) => {
  const { genericStatusesIdMap } = useReferencesContext();

  const status = statusId
    ? genericStatusesIdMap[statusId as GenericStatusId]
    : undefined;

  return (
    <Box
      sx={{
        pt: 4,
        width: '100%',
      }}
    >
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography component="div" gutterBottom variant="h6">
          Informations Techniques
        </Typography>
        <Typography gutterBottom variant="body1">
          Identifiant technique : {id}
        </Typography>
        <Typography gutterBottom variant="body1">
          Créateur : <UserName id={creatorId} />
        </Typography>
        <Typography gutterBottom variant="body1">
          Date création : {formatDateTime(createdAt)}
        </Typography>
        <Typography gutterBottom variant="body1">
          Dernière modification par : <UserName id={updaterId} />
        </Typography>
        <Typography gutterBottom variant="body1">
          Date dernière modification : {formatDateTime(updatedAt)}
        </Typography>
        {!!status && (
          <>
            <Typography
              component="div"
              gutterBottom
              sx={{ mt: 4 }}
              variant="h6"
            >
              Statut
            </Typography>
            <GenericStatusIndicator statusId={status._id} />
          </>
        )}
      </Paper>
    </Box>
  );
};
